import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { CompanyManager } from "../components/CompanyManager";

const CompaniesPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Gestão de Empresas
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Configure manualmente os dados das empresas ou utilize a busca
          automática nos sistemas VIES e OpenCorporates.
        </Typography>
      </Box>
      <Paper sx={{ p: 3 }}>
        <CompanyManager />
      </Paper>
    </Box>
  );
};

export default CompaniesPage;
